import { focusQuantity, validateFocusAmount } from './fm-focus-contribution.js';
document.querySelectorAll('[data-fm-both-submit]').forEach(button => { button.disabled = false; });
document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-fm-support-both]');
  if (!form) return;
  event.preventDefault();
  if (form.dataset.submitting === 'true') return;
  const focusInput = form.querySelector('[data-fm-focus-amount]');
  if (!validateFocusAmount(focusInput)) return;
  const button = form.querySelector('button[type="submit"]');
  const error = form.querySelector('[data-fm-both-error]');
  const selects = [...form.querySelectorAll('[data-fm-both-amount]')];
  if (selects.length !== 1 || selects.some((select) => !/^\d+$/.test(select.value))) {
    error.hidden = false;
    return;
  }
  form.dataset.submitting = 'true';
  button.disabled = true;
  form.setAttribute('aria-busy', 'true');
  error.hidden = true;
  try {
    const response = await fetch(`${form.action}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: focusInput.dataset.fmFocusVariant, quantity: focusQuantity(focusInput.value) }, ...selects.map((select) => ({ id: select.value, quantity: 1 }))] }),
    });
    const result = await response.json();
    if (!response.ok || !Array.isArray(result.items) || result.items.length !== 2) throw new Error('Cart add failed');
    window.location.assign(form.dataset.cartUrl);
  } catch {
    error.hidden = false;
    form.dataset.submitting = 'false';
    button.disabled = false;
    form.removeAttribute('aria-busy');
  }
});
